<template>
  <div @click="openChat" v-if="collapsedChat" class="collapsed-launcher">
    <div class="row-1">
      <img
        src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjYiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyNiAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE4LjM3NSA3LjVDMTguMzc1IDMuNzE4NzUgMTQuMzM1OSAwLjYyNSA5LjQzNzUgMC42MjVDNC40OTYwOSAwLjYyNSAwLjUgMy43MTg3NSAwLjUgNy41QzAuNSA5LjAwMzkxIDEuMTAxNTYgMTAuMzM1OSAyLjEzMjgxIDExLjQ1MzFDMS41MzEyNSAxMi43ODUyIDAuNTg1OTM4IDEzLjgxNjQgMC41ODU5MzggMTMuODE2NEMwLjUgMTMuOTAyMyAwLjQ1NzAzMSAxNC4wNzQyIDAuNSAxNC4yMDMxQzAuNTg1OTM4IDE0LjMzMiAwLjY3MTg3NSAxNC4zNzUgMC44NDM3NSAxNC4zNzVDMi4zOTA2MiAxNC4zNzUgMy42Nzk2OSAxMy44NTk0IDQuNjI1IDEzLjMwMDhDNiAxMy45ODgzIDcuNjc1NzggMTQuMzc1IDkuNDM3NSAxNC4zNzVDMTQuMzM1OSAxNC4zNzUgMTguMzc1IDExLjMyNDIgMTguMzc1IDcuNVpNMjMuNjE3MiAxNi45NTMxQzI0LjYwNTUgMTUuODM1OSAyNS4yNSAxNC41MDM5IDI1LjI1IDEzQzI1LjI1IDEwLjE2NDEgMjIuOTI5NyA3LjY3MTg4IDE5LjY2NDEgNi42NDA2MkMxOS43MDcgNi45NDE0MSAxOS43NSA3LjI0MjE5IDE5Ljc1IDcuNUMxOS43NSAxMi4wNTQ3IDE1LjEwOTQgMTUuNzUgOS40Mzc1IDE1Ljc1QzguOTY0ODQgMTUuNzUgOC40OTIxOSAxNS43NSA4LjA2MjUgMTUuNzA3QzkuMzk0NTMgMTguMTU2MiAxMi41NzQyIDE5Ljg3NSAxNi4zMTI1IDE5Ljg3NUMxOC4wNzQyIDE5Ljg3NSAxOS43MDcgMTkuNDg4MyAyMS4wODIgMTguODAwOEMyMi4wMjczIDE5LjM1OTQgMjMuMzE2NCAxOS44NzUgMjQuOTA2MiAxOS44NzVDMjUuMDM1MiAxOS44NzUgMjUuMTY0MSAxOS44MzIgMjUuMjA3IDE5LjcwMzFDMjUuMjUgMTkuNTc0MiAyNS4yNSAxOS40MDIzIDI1LjEyMTEgMTkuMzE2NEMyNS4xMjExIDE5LjMxNjQgMjQuMTc1OCAxOC4yODUyIDIzLjYxNzIgMTYuOTUzMVoiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo="
        alt="default"
        class="chat-launch-icon"
      />
      <span class="popup-label">Chat with {{ dealerName }}</span>
    </div>
  </div>
  <div v-else class="popup-launcher" :class="{ 'expanded-launcher': !collapsedChat }">
    <div class="row-1">
      <div class="flex">
        <img
          src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjYiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyNiAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE4LjM3NSA3LjVDMTguMzc1IDMuNzE4NzUgMTQuMzM1OSAwLjYyNSA5LjQzNzUgMC42MjVDNC40OTYwOSAwLjYyNSAwLjUgMy43MTg3NSAwLjUgNy41QzAuNSA5LjAwMzkxIDEuMTAxNTYgMTAuMzM1OSAyLjEzMjgxIDExLjQ1MzFDMS41MzEyNSAxMi43ODUyIDAuNTg1OTM4IDEzLjgxNjQgMC41ODU5MzggMTMuODE2NEMwLjUgMTMuOTAyMyAwLjQ1NzAzMSAxNC4wNzQyIDAuNSAxNC4yMDMxQzAuNTg1OTM4IDE0LjMzMiAwLjY3MTg3NSAxNC4zNzUgMC44NDM3NSAxNC4zNzVDMi4zOTA2MiAxNC4zNzUgMy42Nzk2OSAxMy44NTk0IDQuNjI1IDEzLjMwMDhDNiAxMy45ODgzIDcuNjc1NzggMTQuMzc1IDkuNDM3NSAxNC4zNzVDMTQuMzM1OSAxNC4zNzUgMTguMzc1IDExLjMyNDIgMTguMzc1IDcuNVpNMjMuNjE3MiAxNi45NTMxQzI0LjYwNTUgMTUuODM1OSAyNS4yNSAxNC41MDM5IDI1LjI1IDEzQzI1LjI1IDEwLjE2NDEgMjIuOTI5NyA3LjY3MTg4IDE5LjY2NDEgNi42NDA2MkMxOS43MDcgNi45NDE0MSAxOS43NSA3LjI0MjE5IDE5Ljc1IDcuNUMxOS43NSAxMi4wNTQ3IDE1LjEwOTQgMTUuNzUgOS40Mzc1IDE1Ljc1QzguOTY0ODQgMTUuNzUgOC40OTIxOSAxNS43NSA4LjA2MjUgMTUuNzA3QzkuMzk0NTMgMTguMTU2MiAxMi41NzQyIDE5Ljg3NSAxNi4zMTI1IDE5Ljg3NUMxOC4wNzQyIDE5Ljg3NSAxOS43MDcgMTkuNDg4MyAyMS4wODIgMTguODAwOEMyMi4wMjczIDE5LjM1OTQgMjMuMzE2NCAxOS44NzUgMjQuOTA2MiAxOS44NzVDMjUuMDM1MiAxOS44NzUgMjUuMTY0MSAxOS44MzIgMjUuMjA3IDE5LjcwMzFDMjUuMjUgMTkuNTc0MiAyNS4yNSAxOS40MDIzIDI1LjEyMTEgMTkuMzE2NEMyNS4xMjExIDE5LjMxNjQgMjQuMTc1OCAxOC4yODUyIDIzLjYxNzIgMTYuOTUzMVoiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo="
          alt="default"
          class="chat-launch-icon"
        />
        <span class="popup-label">Have a question?</span>
      </div>
      <img
        @click="closeCollapsed"
        src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyLjM0MzggOUwxNy4wMzEyIDQuMzEyNUMxNy42NDA2IDMuNzUgMTcuNjQwNiAyLjgxMjUgMTcuMDMxMiAyLjI1TDE2IDEuMjE4NzVDMTUuNDM3NSAwLjYwOTM3NSAxNC41IDAuNjA5Mzc1IDEzLjkzNzUgMS4yMTg3NUw5LjI1IDUuOTA2MjVMNC41MTU2MiAxLjIxODc1QzMuOTUzMTIgMC42MDkzNzUgMy4wMTU2MiAwLjYwOTM3NSAyLjQ1MzEyIDEuMjE4NzVMMS40MjE4OCAyLjI1QzAuODEyNSAyLjgxMjUgMC44MTI1IDMuNzUgMS40MjE4OCA0LjMxMjVMNi4xMDkzOCA5TDEuNDIxODggMTMuNzM0NEMwLjgxMjUgMTQuMjk2OSAwLjgxMjUgMTUuMjM0NCAxLjQyMTg4IDE1Ljc5NjlMMi40NTMxMiAxNi44MjgxQzMuMDE1NjIgMTcuNDM3NSAzLjk1MzEyIDE3LjQzNzUgNC41MTU2MiAxNi44MjgxTDkuMjUgMTIuMTQwNkwxMy45Mzc1IDE2LjgyODFDMTQuNSAxNy40Mzc1IDE1LjQzNzUgMTcuNDM3NSAxNiAxNi44MjgxTDE3LjAzMTIgMTUuNzk2OUMxNy42NDA2IDE1LjIzNDQgMTcuNjQwNiAxNC4yOTY5IDE3LjAzMTIgMTMuNzM0NEwxMi4zNDM4IDlaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K"
        alt="default"
        class="close-icon"
      />
    </div>
    <div class="row-2">
      <span
        ><span class="dealer-name">{{ dealerName }}:</span> Hi, how can I help you?</span
      >
    </div>
    <div class="row-3">
      <div @click="openChat" class="chat-now-button">Chat Now <span id="rightChevron"></span></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    chatWindowMaximized: {
      type: Boolean,
      default: false,
    },
    dealerName: {
      type: String,
      default: 'Someone',
    },
  },
  data() {
    return {
      collapsedChat: true,
    }
  },
  created() {
    window.addEventListener('scroll', this.expandCollapsed, { once: true })
  },
  methods: {
    openChat() {
      this.$events.triggerEvent('open-chat')
    },
    closeCollapsed() {
      this.collapsedChat = true
    },
    expandCollapsed() {
      this.collapsedChat = false
    },
  },
}
</script>

<style scoped>
.chat-launch-icon {
  width: 16px;
  height: 16px;
  margin: 0px 5px 0px 0px;
}

.collapsed-launcher {
  min-width: 218px;
  height: 50px;
  font-family: 'Open Sans';
  position: fixed;
  right: 25px;
  -webkit-box-shadow: none;
  box-shadow: none;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  border-radius: 4px 4px 0px 0px;
  padding: 15px 20px 20px;
  box-sizing: border-box;
  color: #ffffff;
  cursor: pointer;
}

.popup-launcher {
  width: 350px;
  height: 169px;
  font-family: 'Open Sans';
  position: fixed;
  right: 25px;
  -webkit-box-shadow: none;
  box-shadow: none;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-radius: 4px 4px 0px 0px;
  padding: 15px 20px 20px;
  box-sizing: border-box;
  color: #ffffff;
}

.popup-label {
  color: #ffffff;
  font-size: 16px;
  font-weight: bold;
}

.row-1 {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0px;
  letter-spacing: 0.02em;
}

.row-2 {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  border-radius: 4px;
  background-color: #ffffff;
  color: #000000;
  letter-spacing: 0.01em;
  font-size: 14px;
}

.row-3 {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  padding: 0px;
  letter-spacing: 1px;
  font-size: 14px;
}

.dealer-name {
  font-weight: bold;
}

.chat-now-button {
  border: 1px solid #ffffff;
  border-radius: 4px;
  padding: 9px;
  cursor: pointer;
}

.close-icon {
  height: 10px;
  width: 10px;
  cursor: pointer;
}

#rightChevron::before {
  border-style: solid;
  border-width: 0.15em 0.15em 0 0;
  content: '';
  display: inline-block;
  position: relative;
  transform: rotate(45deg);
  width: 0.35em;
  height: 0.35em;
  left: 0em;
  bottom: 0.15em;
}

.flex {
  display: flex;
  align-items: center;
}
</style>
